import type { FaireProductEntity } from "../../entity_types/product";

export const p_v98mbvdag8: FaireProductEntity = {
  token: "p_v98mbvdag8",
  type: "product",
  name: "I'm So Eggcited Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/2320da1660a092b2359278c7f9dfad009f0eddc1ecd355be9ca012d5f766bdd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b62389b6638930e932fa5c6c44685444f0b6beaa8aa314d38200f03f1b6869c.jpeg",
    "https://cdn.faire.com/fastly/1c0cbdf4360b8fb1cfc5d51f0920eb0e969f0173ac93724edc094ab02083bc69.jpeg",
    "https://cdn.faire.com/fastly/146cda074b283bfaa52b187d592672b1a7791960ba73ba69339794ffe53bb6d5.jpeg",
    "https://cdn.faire.com/fastly/4182029e7166407028ef0496187ab7d3e320659e6377a6ab6595275f6bd12680.jpeg",
    "https://cdn.faire.com/fastly/f068d3637cf6fd2b01a9149acb80f102c3f949362a2047c17a3f04f9d875d1de.jpeg",
    "https://cdn.faire.com/fastly/43b64408d3dad7281c6b0f429657aae71d39b2463857fe8459dbae9c8a8e6af0.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Easter & Spring Collection featuring an all-over design displaying a pattern of Easter bunnies holding colored eggs with a funny seasonal pun that reads \"I'm So Eggcited.\" Easter pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating zigzag pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our I'm So Eggcited kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun Easter kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:12.638Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
